import React from "react";
import { useParams } from "react-router-dom";

import SettingsLayout from "components/Screens/Setting/SettingsLayout/SettingsLayout";
import PolicyDetails from "components/Screens/Setting/PolicyDetails/PolicyDetails";

import { TIME_OFF_ROUTES } from "constants/routes";

import "./PolicyDetails.scss";

function PolicyDetailsWrapper() {
  const { countryName, policyType, policyId } = useParams();

  if (!countryName) {
    return <div>Error: No Country Selected</div>;
  }

  if (!policyType) {
    return <div>Error: No Policy Type Selected</div>;
  }

  const formattedPolicyType = policyType
    .replace(/-/g, " ")
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

  return (
    <SettingsLayout title={formattedPolicyType} linkName="Time Off" link={TIME_OFF_ROUTES.COUNTRY_DETAIL(countryName)}>
      <PolicyDetails policyId={policyId} />
    </SettingsLayout>
  );
}

export default PolicyDetailsWrapper;
